export default __webpack_public_path__ + "static/media/logo.3393d591.png";